export default __webpack_public_path__ + "static/media/github.af2c4d77.svg";